import { FC, useState } from "react";
import { Controls as ReactFlowControls, useReactFlow } from "@xyflow/react";
import { Fab, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useFormContext } from "react-hook-form";
import useOrgchartStore from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Utils/store";
import "./_controls.scss";
import __ from "src/utils/Translations";

interface IControls {
  setFullScreenMode: () => void;
}

enum Modes {
  on = "Pełny ekran",
  off = "Wyłącz pełny ekran",
}

const Controls: FC<IControls> = ({ setFullScreenMode }) => {
  const { zoomOut, zoomIn, fitView } = useReactFlow();
  const [mode, setMode] = useState<Modes>(Modes.on);
  const searchMode = !!useOrgchartStore.getState().searchedNodeId;
  const { resetField } = useFormContext();
  const handleSwitchMode = () => {
    if (mode === Modes.on) {
      setMode(Modes.off);
    } else {
      setMode(Modes.on);
    }
    setFullScreenMode();
  };

  const handleResetSearch = () => {
    resetField("autocomplete", {
      defaultValue: "",
    });
    useOrgchartStore.getState().setSearchedNodeId(null);
  };

  return (
    <ReactFlowControls
      orientation="horizontal"
      position="top-right"
      showInteractive={false}
      showFitView={false}
      showZoom={false}
      className="reactFlowControlRoot"
    >
      {searchMode && (
        <Fab
          variant="extended"
          size="medium"
          color="inherit"
          onClick={handleResetSearch}
        >
          <Typography
            variant="body2"
            textTransform="none"
            fontWeight="fontWeightMedium"
            sx={{ marginRight: "8px" }}
          >
            {__("Zakończ wyszukiwanie")}
          </Typography>
          <Close />
        </Fab>
      )}
      <Fab
        variant="extended"
        size="medium"
        color="primary"
        onClick={() => handleSwitchMode()}
      >
        <Typography
          variant="body2"
          textTransform="none"
          fontWeight="fontWeightMedium"
          sx={{ marginRight: "8px" }}
        >
          {__(mode)}
        </Typography>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7 14H5V19H10V17H7V14ZM5 10H7V7H10V5H5V10ZM17 17H14V19H19V14H17V17ZM14 5V7H17V10H19V5H14Z"
            fill="white"
          />
        </svg>
      </Fab>
      <Fab size="small" color="primary" onClick={() => fitView()}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <path
            d="M4 12H16V4H4V12ZM6 6H14V10H6V6ZM2 11H0V14C0 15.1 0.9 16 2 16H5V14H2V11ZM2 2H5V0H2C0.9 0 0 0.9 0 2V5H2V2ZM18 0H15V2H18V5H20V2C20 0.9 19.1 0 18 0ZM18 14H15V16H18C19.1 16 20 15.1 20 14V11H18V14Z"
            fill="white"
          />
        </svg>
      </Fab>
      <Fab
        size="small"
        color="primary"
        onClick={() => zoomOut({ duration: 400 })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M19 13H5V11H19V13Z" fill="white" />
        </svg>
      </Fab>
      <Fab
        size="small"
        color="primary"
        onClick={() => zoomIn({ duration: 400 })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white" />
        </svg>
      </Fab>
    </ReactFlowControls>
  );
};

export default Controls;
